import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CoinIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 19.75C14.9489 19.75 17.0797 19.3899 18.7826 18.7837C18.8213 18.7724 18.8591 18.7587 18.8957 18.7429C19.3151 18.5892 19.7079 18.4203 20.0722 18.2382C21.8675 17.3405 23.25 15.9568 23.25 14.25V9.75C23.25 7.88219 21.6517 6.50851 19.8133 5.66006C17.8901 4.7724 15.3034 4.25 12.5 4.25C9.69658 4.25 7.10991 4.7724 5.18665 5.66006C3.34834 6.50851 1.75 7.88219 1.75 9.75V14.25C1.75 15.9568 3.13249 17.3405 4.92779 18.2382C5.29212 18.4203 5.68485 18.5892 6.10429 18.7429C6.14093 18.7587 6.1787 18.7724 6.21745 18.7837C7.92035 19.3899 10.0512 19.75 12.5 19.75ZM6.02477 7.47598C4.33427 8.25621 3.75 9.13253 3.75 9.75C3.75 10.3675 4.33427 11.2438 6.02477 12.024C7.63032 12.765 9.91865 13.25 12.5 13.25C15.0814 13.25 17.3697 12.765 18.9752 12.024C20.6657 11.2438 21.25 10.3675 21.25 9.75C21.25 9.13253 20.6657 8.25621 18.9752 7.47598C17.3697 6.73496 15.0814 6.25 12.5 6.25C9.91865 6.25 7.63032 6.73496 6.02477 7.47598ZM21.25 13.0195C20.8083 13.3324 20.3199 13.6061 19.8133 13.8399C19.7108 13.8873 19.6063 13.9336 19.5 13.9788V16.279C20.8254 15.5373 21.25 14.7544 21.25 14.25V13.0195ZM13.5 15.2277C14.9274 15.1636 16.2817 14.9633 17.5 14.649V17.0983C16.3833 17.4287 15.0411 17.6579 13.5 17.7277V15.2277ZM7.5 17.0983C8.61675 17.4287 9.95893 17.6579 11.5 17.7277V15.2277C10.0726 15.1636 8.71834 14.9633 7.5 14.649V17.0983ZM5.5 13.9788C5.39371 13.9336 5.28924 13.8873 5.18665 13.8399C4.68007 13.6061 4.19171 13.3324 3.75 13.0195V14.25C3.75 14.7544 4.17464 15.5373 5.5 16.279V13.9788Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CoinIcon = assignWithoutSideEffects(_CoinIcon, {
  componentId: 'CoinIcon',
});

export default CoinIcon;
